import React from "react";
import Eligibility from "./Eligibility";
import CreditScore from "./CreditScore";
import Approval from "./Approval";
import Faq from "./Faq";
import { Helmet } from "react-helmet-async";

const index = () => {
  return (
    <>
      <Helmet>
        <title>Credit Pro Dashboard - Minemi</title>
      </Helmet>
      <Eligibility />
      <CreditScore />
      <Approval />
      <Faq />
    </>
  );
};

export default index;
